// default imports
import React, { Component } from 'react';
import './NotFound.css';

// material imports
import Typography from '@material-ui/core/Typography';

class NotFound extends Component {

  render() {
    return (

      <div id="not-found">
        <Typography>
          Hello NotFound!
        </Typography>
      </div>

    );
  }
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/NotFound.js